import React from 'react';

const Scroll = () => {

    return (
        <div className="scroll" id="scroll">
            <span>Scroll</span>
            <span>Scroll</span>
            <span>Scroll</span>
            <span>Scroll</span>
            <span>Scroll</span>
            <span>Scroll</span>
        </div>
    );

};

export default Scroll;


// WEBPACK FOOTER //
// ./src/js/components/Scroll.js